import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';

import {
  DeviceNameCommands,
  DeviceNameProperties,
  DeviceRoles,
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  SignalProperties,
} from '@vi-iot/client';

import { lowLqiSignalThreshold } from '@common';
import { DevicesStore, GatewayStore, InstallationFeaturesStore } from '@store';

import { FeatureTileIconVariant } from '../../../shared/components/feature-tile/feature-tile-variants';
import { FeaturesDetailsOverlayTypeEnum } from '../installation-overlay.model';

@Component({
  selector: 'app-remote-controller',
  templateUrl: './remote-controller.component.html',
  styleUrls: ['./remote-controller.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemoteControllerComponent {
  availableOverlays = FeaturesDetailsOverlayTypeEnum;
  readonly featurePropertyKey = FeaturePropertyKey;
  readonly lowLqiSignalThreshold = lowLqiSignalThreshold;
  readonly iconVariant = FeatureTileIconVariant;
  deviceRoles = DeviceRoles.RemoteControllerVitotrol100E;
  constructor(
    public devicesStore: DevicesStore,
    public gatewayDevices: GatewayStore,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  getLqiFeature(deviceId: string): Observable<Feature<SignalProperties, never>> {
    return this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceZigbeeLqi,
      deviceId
    );
  }

  getDeviceDescription(
    deviceId: string
  ): Observable<Feature<DeviceNameProperties, DeviceNameCommands>> {
    return this.installationFeaturesStore.selectInstallationDeviceFeature<
      DeviceNameProperties,
      DeviceNameCommands
    >(FeatureNames.deviceName, deviceId);
  }
}
